/**
 * Version utility for Quad Atlas
 * Manual versioning - increment this number with each update
 */
// Current version - increment manually with each update
const CURRENT_VERSION = 'v204'
export function getAtlasVersion(): string {
  const w = window as any
  // Allow manual override via window if needed
  if (w.__ATLAS_VERSION__) {
    return w.__ATLAS_VERSION__
  }
  return CURRENT_VERSION
}
export function getBuildInfo(): { version: string; buildTime: string } {
  return {
    version: getAtlasVersion(),
    buildTime: new Date().toISOString(),
  }
}
